import React from 'react';
import { Card, Typography } from 'antd';
// Components
import AgencySignUpEmailVerificationSettings from './components/AgencySignUpEmailVerificationSettings/AgencySignUpEmailVerificationSettings';
import PersonalEmailDomainsSettings from './components/PersonalEmailDomainsSettings/PersonalEmailDomainsSettings';
// Styles
import styles from './CbSignUpSettings.module.scss';

const { Title } = Typography;

const CbSignUpSettings = (): JSX.Element => (
  <div className={styles.root}>
    <Title level={2}>Sign Up</Title>
    <Card>
      <AgencySignUpEmailVerificationSettings />
    </Card>
    <Card className={styles.section}>
      <PersonalEmailDomainsSettings />
    </Card>
  </div>
);

export default CbSignUpSettings;
